import React, { Component } from 'react';
import { ResponsiveBar } from '@nivo/bar';

import classNames from 'classnames/bind';
import style from './BarChart.scss';

const ctx = classNames.bind(style);

class BarChart extends Component {
  render() {
    const { data, title, source } = this.props;

    return (
      <div className={ctx('bar-chart')}>
        <div className={ctx('title')}>{title}</div>
        <div className={ctx('area')}>
          <ResponsiveBar
            {...data}
            margin={{
              top: 40,
              right: 10,
              bottom: 80,
              left: 60,
            }}
            colorBy={({ id, data }) => data[`${id}Color`]}
            padding={0.3}
            borderColor="inherit:darker(1.6)"
            labelSkipWidth={12}
            labelSkipHeight={12}
            animate
            motionStiffness={90}
            motionDamping={15}
            legends={[
              {
                dataFrom: 'keys',
                anchor: 'bottom-right',
                direction: 'row',
                justify: false,
                itemsSpacing: 2,
                itemWidth: 100,
                translateY: 75,
                itemHeight: 20,
                itemDirection: 'left-to-right',
                itemOpacity: 0.85,
                symbolSize: 20,
                effects: [
                  {
                    on: 'hover',
                    style: {
                      itemOpacity: 1,
                    },
                  },
                ],
              },
            ]}
          />
        </div>
        <div className={ctx('source')}>{source}</div>
      </div>
    );
  }
}

export default BarChart;
